import { render, staticRenderFns } from "./SSOForm.vue?vue&type=template&id=ffa19218"
import script from "./SSOForm.vue?vue&type=script&lang=js"
export * from "./SSOForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports